"use strict";
exports.__esModule = true;
exports.roundings = exports.spacings = exports.opacities = exports.opacityColors = exports.colors = exports.shadows = exports.fonts = void 0;
var tokens_1 = require("./tokens");
exports.colors = tokens_1.colors;
exports.fonts = tokens_1.fonts;
exports.opacities = tokens_1.opacities;
exports.opacityColors = tokens_1.opacityColors;
exports.roundings = tokens_1.roundings;
exports.shadows = tokens_1.shadows;
exports.spacings = tokens_1.spacings;
